<template >
  <b-container fluid class="mb-3">
    <b-row align-h="center" v-if="cfdisContribuyenteActual.length < 1"><h5 class="error">Este recibo no cuenta con facturación</h5></b-row>
    <b-row align-h="center" v-if="cfdisContribuyenteActual.length > 0"><h5 >Facturas ligadas al recibo</h5></b-row>
    <!--<b-row align-h="center"><h5></h5></b-row>-->
    <b-table 
        v-if="cfdisContribuyenteActual != null && cfdisContribuyenteActual.length > 0"
        style="min-height:180px;" 
        :busy="tableIsBusy" 
        :sticky-header="cfdisContribuyenteActual != null && cfdisContribuyenteActual.length > 1" 
        stacked="sm" 
        :responsive=" 'md' || cfdisContribuyenteActual != null && cfdisContribuyenteActual.length > 1" 
        fixed striped small 
        :items="cfdisContribuyenteActual" 
        :fields="fieldsTableCfdis">

            <template v-slot:cell(acciones)="row" >                
                <b-dropdown id="dropdown-fact" text="Acciones" variant="success" size="sm">
                    <b-dropdown-item  @click="descargarPdf(row.item.pdf.b64, row.item.uuid)"><b-icon icon="download"/> Descargar PDF</b-dropdown-item>
                    <b-dropdown-item  @click="descargarXml(row.item.uuid, row.item.xml.b64)"><b-icon icon="download"/> Descargar XML</b-dropdown-item>
                    <b-dropdown-item  @click="cancelarFactura(row.item.uuid)"><b-icon icon="x-circle"/> Cancelar</b-dropdown-item>
                    <b-dropdown-item  @click="actualizarFactura(row.item.uuid)"><b-icon icon="arrow-repeat"/> Actualizar</b-dropdown-item>
                </b-dropdown>
            </template>
            <template #table-busy>
                <div class="text-center text-success my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong> Cargando ...</strong>
                </div>
            </template>
    </b-table>
   
    <b-modal title="Resultado de la operación" size="lg" v-model="isShowModalResults"  header-bg-variant="dark" header-text-variant="light" hide-footer>
        <b-form-textarea
            v-model="msgResultFact"
            rows="5"
            :disabled="true"
        ></b-form-textarea>
    </b-modal>
  </b-container>
</template>
<script>
    import { mapState} from 'vuex';
    import axios from 'axios';
    import { server, checkAuth, getGetConfig, handledError } from '@/axios-tools';
    import { downloadB64Pdf, generarTxtFile } from '@/vue-tools';

    export default {
        props: ['dataFacturacion'],
        computed: mapState ({
            token: state => state.login.token,
            cfdisContribuyenteActual: state=> state.formas.cfdisContribuyenteActual
        }),
        data() {
            return {
                serie: this.dataFacturacion.folioRecibo.substring(0,2),
                folio: this.dataFacturacion.folioRecibo.substring(2,8),
                total: this.dataFacturacion.total,
                rfc:"",
                formasPago:"",
                email:"",
                tipoFacturacion:null,
                optionsFormaPago:["Efectivo", "Cheque", "Transferencia", "Crédito", "Débito", "Por definir"],
                fieldsTableCfdis: [
                              //{key: 'uuid', label: 'UUID'},
                              //{key: 'fechaFact', label: 'Fecha de Facturación'},
                              {key: 'estado', label: 'Estado'},
                              {key: 'tipo', label: 'Tipo'},
                              {key: 'fechaFact', label: 'Fecha'},
                              {key: 'total', label: 'Total'},
                              {key: 'acciones', label: 'Acciones'}
                            ],
                tableIsBusy:false,
                msgResultFact:null,
                isShowModalResults:false
            }
        },
        methods: {
            descargarPdf(b64, uuid){
                downloadB64Pdf(b64, uuid);
            },
            /*
            descargarXml(uuid){
                if(checkAuth(this.$router, this.$store)){
                    axios(
                            getGetConfig(server.descargarCfdi, {uuid:uuid}, this.token)
                        )
                        .then(res => {
                            alert(res.data);
                        }).catch(err => {
                            handledError(err, server.descargarCfdi, this.$router, this.$store);
                        });
                }
            },*/
            descargarXml(uuid, xml){
                generarTxtFile(uuid, xml, 'xml');
            },
            cancelarFactura(uuid){
                if(checkAuth(this.$router, this.$store)){
                    this.tableIsBusy=true;
                    axios(
                            getGetConfig(server.cancelarCfdi, null, this.token, {uuid:uuid})
                        )
                        .then(res => {
                            this.msgResultFact = res.data;
                            this.isShowModalResults=true;
                            this.tableIsBusy=false;
                        }).catch(err => {
                            handledError(err, server.cancelarCfdi, this.$router, this.$store);
                        });
                }
            },
            actualizarFactura(uuid){
                if(checkAuth(this.$router, this.$store)){
                    this.tableIsBusy =true;
                    axios(
                        getGetConfig(server.actualizarCfdi, null, this.token, {uuid:uuid})
                    )
                    .then(res => {
                        this.msgResultFact = res.data;
                        this.$store.commit('updateEstadoCfdiContribuyenteActual', {uuid:uuid, estado:res.data});
                        this.isShowModalResults=true;
                        this.tableIsBusy=false;
                    }).catch(err => {
                        handledError(err, server.actualizarCfdi, this.$router, this.$store);
                        this.tableIsBusy=false;
                    });
                }
            },
        }
    }
</script>
<style>
.error {color: red;}
</style>